import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { LAZY_DEFAULT_TIMEOUT as timeout } from '../../common/Constants';

export default universal(universalImport({
    chunkName: () => 'TypeaheadSuggestionBox',
    path: () => path.join(__dirname, './TypeaheadSuggestionBox'),
    resolve: () => require.resolveWeak('./TypeaheadSuggestionBox'),
    load: () => Promise.all([
        import(/* webpackChunkName: "TypeaheadSuggestionBox" */'./TypeaheadSuggestionBox'),
    ]).then(proms => proms[0]),
}), {
    loading: () => null,
    error: () => null,
    timeout,
});
